module.exports = __webpack_public_path__ + "img/mayo.e84a52a7.svg";